/**
 * ============================================================
 * ThinkCricket / Shopify Contact Form — Spam Protection
 * Features:
 *   1. Honeypot field validation
 *   2. Time-based submission guard (< 5 seconds = bot)
 *   3. Suspicious keyword detection in message body
 * ============================================================
 */

(function () {
  "use strict";

  // --- Configuration ---
  const CONFIG = {
    minSubmitSeconds: 5,          // Minimum seconds before allowing submission
    honeypotFieldName: "contact[website]",
    timestampFieldId: "contact_form_loaded_at",
    messageFieldName: "contact[body]",

    // Add/remove keywords as needed (all lowercase)
    spamKeywords: [
      "casino",
      "crypto",
      "cryptocurrency",
      "bitcoin",
      "loan",
      "loans",
      "payday",
      "forex",
      "seo service",
      "buy followers",
      "make money fast",
      "earn from home",
      "click here",
      "free money",
      "http://",
      "https://",
    ],
  };

  // --- Utility: Show an inline error message above the submit button ---
  function showError(form, message) {
    // Remove any existing spam error
    const existing = form.querySelector(".spam-protection-error");
    if (existing) existing.remove();

    const errorEl = document.createElement("p");
    errorEl.className = "spam-protection-error";
    errorEl.setAttribute("role", "alert");
    errorEl.style.cssText = [
      "color: #c0392b",
      "background: #fdf0ef",
      "border: 1px solid #e74c3c",
      "border-radius: 4px",
      "padding: 12px 16px",
      "margin-bottom: 16px",
      "font-size: 0.95rem",
      "font-weight: 500",
    ].join(";");
    errorEl.textContent = message;

    // Insert before the submit button
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      form.insertBefore(errorEl, submitBtn);
    } else {
      form.appendChild(errorEl);
    }

    // Scroll error into view
    errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  // --- Validation 1: Honeypot check ---
  function isHoneypotFilled(form) {
    const honeypot = form.querySelector(
      `[name="${CONFIG.honeypotFieldName}"]`
    );
    return honeypot && honeypot.value.trim() !== "";
  }

  // --- Validation 2: Time-based check ---
  function isSubmittedTooFast(form) {
    const timestampField = form.querySelector(`#${CONFIG.timestampFieldId}`);
    if (!timestampField || !timestampField.value) return true; // No timestamp = suspicious

    const loadedAt = parseInt(timestampField.value, 10);
    const now = Date.now();
    const elapsedSeconds = (now - loadedAt) / 1000;

    return elapsedSeconds < CONFIG.minSubmitSeconds;
  }

  // --- Validation 3: Spam keyword check ---
  function containsSpamKeywords(form) {
    const messageField = form.querySelector(
      `[name="${CONFIG.messageFieldName}"]`
    );
    if (!messageField) return false;

    const messageText = messageField.value.toLowerCase();
    return CONFIG.spamKeywords.some((keyword) =>
      messageText.includes(keyword.toLowerCase())
    );
  }

  // --- Stamp the page-load time into the hidden timestamp field ---
  function stampLoadTime(form) {
    const timestampField = form.querySelector(`#${CONFIG.timestampFieldId}`);
    if (timestampField) {
      timestampField.value = Date.now().toString();
    }
  }

  // --- Main init ---
  function init() {
    // Shopify contact forms have id="contact_form" by convention in Dawn
    const form = document.querySelector(
      'form[action*="/contact"]'
    );

    if (!form) return; // Not a contact page, do nothing

    // Stamp load time immediately
    stampLoadTime(form);

    form.addEventListener("submit", function (event) {
      // Clear previous error
      const existing = form.querySelector(".spam-protection-error");
      if (existing) existing.remove();

      // Run all checks in order
      if (isHoneypotFilled(form)) {
        // Silently block — bots shouldn't know they were caught
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
      }

      if (isSubmittedTooFast(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(
          form,
          "Please take a moment to review your message before submitting."
        );
        return false;
      }

      if (containsSpamKeywords(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(
          form,
          "Your message contains content that cannot be submitted. Please remove any URLs or restricted keywords and try again."
        );
        return false;
      }

      // All checks passed — allow Shopify's default form submission
    });
  }

  // Run after DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();